import Typography from 'components/global/Typography';

import useLocale from 'hooks/useLocale';

const DateTimeViewer = ({ value }) => {
	const { getLocaleDateWithTime } = useLocale();
	return <Typography>{value && getLocaleDateWithTime(value)}</Typography>;
};

export default DateTimeViewer;
